import { Dispatch, ReactNode, SetStateAction } from 'react';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import {
    Quotation,
    QuotationFormErrors
} from '../../../../../../interfaces/Quotation';
import { Currency } from '../../../../../../pages/dashboard/payments/interfaces/Currency';
import { TransformedItems } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import FormFooter from '../../../common/FormFooter';
import StepOne from './StepOne';
import StepTwo from './StepTwo';

interface QuotationMobileFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: Quotation;
    corporatePartners: CorporatePartner[];
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    errors: QuotationFormErrors;
    quoteFields: TransformedItems[];
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    removeQuoteField: (index: number) => void;
    currencies: Currency[];
    totalAmount: number;
    addQuoteField: () => void;
    loadingCurrencies: boolean;
    setSignatureUrlBase64: (value: string) => void;
    signatureUrlBase64: string;
    activeStep: number;
    setActiveStep: (step: number) => void;
    onSaveOnlyAction?: () => void;
    showPreview: boolean;
    setShowPreview: (val: boolean) => void;
}

const QuotationMobileForm = ({
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    currencies,
    addQuoteField,
    loadingCurrencies,
    setSignatureUrlBase64,
    signatureUrlBase64,
    totalAmount,
    activeStep,
    setActiveStep,
    onSaveOnlyAction,
    showPreview,
    setShowPreview
}: QuotationMobileFormProps) => {
    const views: {
        [key: number]: ReactNode;
    } = {
        0: (
            <StepOne
                {...{
                    updateField,
                    payload,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    errors,
                    quoteFields,
                    updateQuoteField,
                    removeQuoteField,
                    addQuoteField,
                    activeStep,
                    setActiveStep
                }}
            />
        ),
        1: (
            <StepTwo
                {...{
                    updateField,
                    payload,
                    errors,
                    currencies,
                    loadingCurrencies,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    totalAmount,
                    onSaveOnlyAction,
                    showPreview,
                    setShowPreview
                }}
            />
        )
    };

    return (
        <div className='lg:hidden pt-4'>
            {views[activeStep]}
            <FormFooter
                onContinue={() => {
                    setActiveStep(activeStep + 1);
                }}
                onSave={() => onSaveOnlyAction && onSaveOnlyAction()}
                onPreview={() => setShowPreview(!showPreview)}
                onGoBack={() => {
                    setActiveStep(activeStep - 1);
                }}
                steps={2}
                activeStep={activeStep}
                disabled={Object.values(payload).some(
                    (item) => item === undefined
                )}
            />
        </div>
    );
};

export default QuotationMobileForm;
